import { Pipe, PipeTransform } from '@angular/core';
import { roles } from '../entities/app.entity';

@Pipe({
  name: 'role',
})
export class RolePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    const role = roles.find((role) => role.value === value);

    return role ? role.label : value;
  }
}
